/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { mFIGetTryInStoreInfoAsync } from './TryInStoreDataActionExtension.g';
import { IMFITryInStore, IMFITryInStoreInfoResponse } from './TryInStoreDataServiceEntities.g';

/**
 * GetTryInStoreInfo Input Action
 */

export class GetTryInStoreInfoInput implements Msdyn365.IActionInput {
    //   Construct the input needed to run the action
    public input: IMFITryInStore;
    constructor(input: IMFITryInStore) {
        this.input = input;
    }

    //   Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () =>
        `Try-In-Store${this.input.StoreId}-${this.input.ZipCode}-${this.input.Radius}-${this.input.Limit}-${this.input.Products}`;
    public getCacheObjectType = () => 'GetTryInStoreInfo';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

//   Create a data model here or import one to capture the response of the action
/**
 *   Use this function to create the input required to make the action call
 */
// const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
//     return new GetTryInStoreInfoInput();
// };

/**
 *   Use this function to call your action and process the results as needed
 */
async function getTryInStoreAction(
    request: GetTryInStoreInfoInput,
    ctx: Msdyn365.IActionContext
): Promise<IMFITryInStoreInfoResponse | {}> {
    if (request.input) {
        try {
            const result = await mFIGetTryInStoreInfoAsync({ callerContext: ctx }, request.input);
            if (result) {
                return result;
            }
        } catch (error) {
            console.log('Error', error);
        }
    }
    return {};
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IMFITryInStoreInfoResponse | {}>>getTryInStoreAction,
    //   Give your data action a unique id
    id: 'GetTryInStoreInfo'
    // input: createInput
    //   Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
